import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home.vue'
import LoginUser from "@/lib/components/LoginUser";
import CardsetDetail from "@/components/cardsets/CardsetDetail";
import StackDetail from "@/components/stacks/StackDetail";
import StackQuiz from "@/components/stacks/StackQuiz";
import LogOutUser from "@/lib/components/LogOutUser";
import SetLanguage from "@/components/SetLanguage";
import GetToken from "@/lib/components/GetToken";
import CardEdit from "../components/cards/CardEdit";
import StackCardList from "../components/stacks/StackCardList";
import PrivacyPolicy from "@/views/PrivacyPolicy";
import StackDrillChoice from "@/views/StackDrillChoice";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/auth/token',
    component: GetToken,
    name: 'get-token',
    props: route => ({ jwt: route.query.jwt }),
  },
  {
    path: '/login',
    component: LoginUser,
    name: 'login'
  },
  {
    path: '/logout',
    component: LogOutUser,
    name: 'logout',
  },
  {
    path: '/set-lang',
    component: SetLanguage,
    name: 'set-lang',
    props: route => ({ lang: route.params.lang })
  },
  {
    path: '/cardset/:pk',
    component: CardsetDetail,
    name: 'cardset-detail',
    props: (route) => ({ pk: Number(route.params.pk) })
  },
  {
    path: '/card/:pk/update/',
    component: CardEdit,
    name: 'card-update',
    props: (route) => ({ pk: Number(route.params.pk) })
  },
  {
    path: '/stack/:cardsetId/:pk/quiz/:level',
    component: StackQuiz,
    name: 'stack-quiz',
    props: (route) => ({
      stackId: Number(route.params.pk),
      level: Number(route.params.level),
      cardsetId: Number(route.params.cardsetId)
    })
  },
  {
    path: '/stack/:cardsetId/:pk/detail',
    component: StackDetail,
    name: 'stack-detail',
    props: (route) => ({
      pk: Number(route.params.pk),
      cardsetId: Number(route.params.cardsetId)
    })
  },
  {
    path: '/stack/:cardsetId/:pk/drill',
    component: StackDrillChoice,
    name: 'stack-drill',
    props: (route) => ({
      pk: Number(route.params.pk),
      cardsetId: Number(route.params.cardsetId)
    })
  },
  {
    path: '/stack-card-list/:pk',
    component: StackCardList,
    name: 'stack-card-list',
    props: (route) => ({ pk: Number(route.params.pk) })
  },
  // {
  //   path: '/',
  //   component: StackQuiz,
  //   name: 'quiz',
  //   props: { stackId: 57 }
  // },
  {
    path: '/hebrew',
    name: 'hebrew',
    component: CardsetDetail,
    props: {pk: 5}
  },
  {
    path: '/privacy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    // props: {pk: 5}
  },
];

const router = new VueRouter({
  routes
});

export default router
